import React from 'react'
import { OnChange } from 'react-final-form-listeners'

import { DamageSection } from '../types'

const FetchOnChange: React.FC<{ name: DamageSection; fields: DamageSection[]; action: any }> = ({
  name,
  fields = [],
  action,
}) => (
  <OnChange name={name}>
    {(value) => {
      fields.forEach((field) => !!value && action(name, value, field))
    }}
  </OnChange>
)

export default FetchOnChange
